import React from "react"
import { Button } from "react-bootstrap"

export default function ClearFiltersButton({ onClick, others }) {

  const renderOthers = () => {
    if (!others || !others.length) return
    return others.map((item, index) => <span key={ index }>{ item }</span>)
  }

  return (
    <div className="mb-15 flex-row-simple flex-wrap gap-10 justify-end">

      <Button bsStyle="default" onClick={ onClick } className="font-size-13"
        title="Clear all filters">
        CLEAR FILTERS
      </Button>

      { renderOthers() }
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/fragments/ClearFiltersButton.js